import { Reveal, Eyebrow } from "./Reveal";
import { FAMILY_VIDEO, FAMILY_POSTER, FAMILY_IMAGES } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

export const Families = () => {
  const { t } = useLang();
  return (
    <section
      id="families"
      data-testid="families-section"
      className="py-24 md:py-36 bg-secondary/40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal y={40} className="overflow-hidden">
              <video
                data-testid="family-video"
                className="w-full h-[360px] md:h-[560px] object-cover"
                src={FAMILY_VIDEO}
                poster={FAMILY_POSTER}
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
              />
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>{t.families.eyebrow}</Eyebrow>
              <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-tight">
                {t.families.title}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-7 text-muted-foreground text-base md:text-lg font-light leading-relaxed max-w-lg">
                {t.families.p}
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-4">
                {t.families.perks.map((p, i) => (
                  <li
                    key={i}
                    data-testid={`family-perk-${i}`}
                    className="flex items-start gap-3 text-foreground/80"
                  >
                    <span className="mt-2 h-1.5 w-1.5 bg-accent shrink-0" />
                    <span className="font-light">{p}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 mt-10 md:mt-14">
          {FAMILY_IMAGES.map((src, i) => (
            <Reveal key={i} delay={i * 0.08} className="overflow-hidden group">
              <img
                data-testid={`family-image-${i}`}
                src={src}
                alt="Families enjoying a beach day at Tribe Beach Lounge, Tigaki, Kos"
                className="w-full h-44 md:h-64 object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
